import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import MainRu from "./pages/MainRu";
import MainDe from "./pages/MainDe";
import Card from "./pages/Card";

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<MainRu />} />
                <Route path="/Deutsch" element={<MainDe />} />
                <Route path="/card" element={<Card />} />
            </Routes>
        </BrowserRouter>
    );
}
